/**
 * Page View Event Builder
 * Factory function to create page view dataLayer events
 */

import { GaEventType } from '../types';
import { PageView, PageViewEvent } from '../types';
import { buildBaseEvent } from './base-event-builder';

/**
 * Build a page view event
 */
export function buildPageViewEvent<T extends PageView>(options: T): PageViewEvent {
    // Add page location by default if not provided
    const optionsWithDefaults = {
        ...options,
        pageLocation: options.pageLocation || (typeof window !== 'undefined' ? window.location.href : ''),
    };

    return buildBaseEvent<PageViewEvent>(GaEventType.PageView, optionsWithDefaults);
}
